import React, { useEffect } from 'react'
import Login from './components/pages/Login';
import Home from './components/pages/Home';
import Spinner from './components/content/Spinner';
import { useState } from 'react'
import {jwtDecode} from 'jwt-decode';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  //const loginToken = localStorage.getItem("loginToken");

  const isTokenExpired = (token) => {
    if (!token) return true;
    try {
      let decodedToken = jwtDecode(token);
      let currentTime = Date.now() / 1000;
      return decodedToken.exp < currentTime;
    } catch (error) {
      //console.error('Error decoding token:', error);
      return true;
    }
  };
  
  useEffect(() => {
  
    if (localStorage.getItem('loginToken')) {
      const token = localStorage.getItem('loginToken');
      if (isTokenExpired(token)) {
        localStorage.removeItem('loginToken');
        // setLoading(false);
        setIsLoggedIn(false);
        //router.push('/login');
      } else {
        
        //setUser(JSON.parse(localStorage.getItem('user')));
        setIsLoggedIn(true);
      }
    } else {
      //router.push('/login');
      // setLoading(false);
      setIsLoggedIn(false);
    }

/*
    const checkToken = async () => {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": loginToken
        },
        redirect: "manual"
      };
      await fetch("https://arobaniworks.com/api/support/checktoken", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success === 1) {
            setIsLoggedIn(true);
            setLoading(false);
          }else{
            setIsLoggedIn(false);
            setLoading(false);
          }
        })
        .catch((error) => console.log(error))
    }
    checkToken()
*/

  },[])
  
  function updateIsLoggedIn(answer){
    setIsLoggedIn(answer)
  } 
  
  //Spinner Center.
  //<div style={{display: "flex", justifyContent: "center", alignItems:"center",height: "100vh"}}>Loading...</div>
  

  return (
    <>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      { isLoggedIn ? <Home updateIsLoggedIn = {updateIsLoggedIn}/> : isLoading?<Spinner />:<Login setIsLoading={setIsLoading} updateIsLoggedIn = {updateIsLoggedIn} /> }
      
    </>
  )

}

export default App;
